import React from "react";
import Moment from "moment";
import renderHTML from "react-render-html";

import Tag from "../../components/Tag";
import ManageButtonGroup from "./ManageButtonGroup";

const ExhibitList = ({ exhibits, deleteExhibit }) => {
  if (exhibits.length) {
    return (
      <div>
        <p>{exhibits.length} exhibits found...</p>
        <table className="table table-condensed table-hover">
          <tbody>
            {exhibits.map(e => {
              return (
                <tr key={e.exh_id}>
                  <td>
                    <h4>{e.exh_title}</h4>
                    {renderHTML(e.exh_desc)}
                    <div>
                      {e.tags.map(t => {
                        return <Tag text={t.tag_name} key={t.tag_id} />;
                      })}
                    </div>
                    <ManageButtonGroup
                      exhibitID={e.exh_id}
                      deleteExhibit={deleteExhibit}
                    />
                    <br />
                    <small>
                      <em>
                        Last Updated:{" "}
                        {Moment(e.exh_updated_at).format("MM-DD-YYYY")}
                      </em>
                    </small>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  } else {
    return (
      <div>
        <p>0 exhibits found...</p>
      </div>
    );
  }
};

export default ExhibitList;



// WEBPACK FOOTER //
// ./src/pages/Exhibits/ExhibitList.jsx